import Http from '@/api/http.js'

export default {

  index() {
    return Http.get(`/refill_stocks`)
  },

  indexByModel({model = 'modalities', id}) {
    return Http.get(`${model}/${id}/refill_stocks`)
  },

  update(refill_stock){
    return Http.put(`/refill_stocks/${refill_stock.id}`, {
      refill_stock: {...refill_stock},
    });
  },

  show(id) {
    return Http.get(`/refill_stocks/${id}`);
  },


}
